import React from 'react';

import DataModelView from '../../common/view/DataModelView';

export default class OptInSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'contracts'
    ];
  }

  render() {
    return (
      <div>
        {this.state.contracts.map((contract) => {
          return contract.minimumOptInCount > 0
            ? (
              <div key={contract.code} className="dx-fieldset">
                <div className="dx-fieldset-header">{contract.displayName}</div>
                <div className="dx-field">
                  <div className="dx-field-label">Minimum Election Days</div>
                  <div className="dx-field-value-static">{contract.minimumOptInCount.toLocaleString(this.props.locale)}</div>
                </div>
                <div className="dx-field">
                  <div className="dx-field-label">Days Elected</div>
                  <div className="dx-field-value-static">{contract.currentOptInCount.toLocaleString(this.props.locale)}</div>
                </div>
              </div>)
            : (<div key={contract.code} />);
        })}
      </div>
    );
  }
}